/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ShardingInputs */

const en_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharding`)
};

const ar_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقسيم`)
};

const bn_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শার্ডিং`)
};

const de_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharding`)
};

const es_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragmentación`)
};

const fr_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partage`)
};

const pt_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragmentação`)
};

const zh_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分片`)
};

const tr_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parçalama`)
};

const ru_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шардинг`)
};

const pl_svchip_sharding = /** @type {(inputs: Svchip_ShardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragmentowanie`)
};

/**
* | output |
* | --- |
* | "Sharding" |
*
* @param {Svchip_ShardingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_sharding = /** @type {((inputs?: Svchip_ShardingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ShardingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_sharding(inputs)
	if (locale === "bn") return bn_svchip_sharding(inputs)
	if (locale === "de") return de_svchip_sharding(inputs)
	if (locale === "es") return es_svchip_sharding(inputs)
	if (locale === "fr") return fr_svchip_sharding(inputs)
	if (locale === "pt") return pt_svchip_sharding(inputs)
	if (locale === "zh") return zh_svchip_sharding(inputs)
	if (locale === "tr") return tr_svchip_sharding(inputs)
	if (locale === "ru") return ru_svchip_sharding(inputs)
	if (locale === "pl") return pl_svchip_sharding(inputs)
	return en_svchip_sharding(inputs)
});